<template>
  <el-dialog
    :visible="visible"
    width="600px"
    @close="closeFn"
    title="添加增远程升级文件"
    >

    <div class="form">
      <el-upload
        class="up__btn"
        action=""
        :http-request="({ file }) => (excelFile = file)"
        :show-file-list="false"
      >
        <div v-if="!excelFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传文件，且不超过500kb</div>
        </div>
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="label">{{ excelFile.name }}</div>
        </div>
      </el-upload>
    </div>
    <div class="footer">
      <el-button @click="closeFn">取 消</el-button>
      <el-button @click="onConfirm" type="primary">上 传</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name:'FileForm',
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      loading:false,
      excelFile:null
    }
  },
  methods:{
    //关闭弹框
    closeFn(){
      this.excelFile = null;
      this.$emit('update:visible',false);
    },

    //上传文件
    async onConfirm(){
      let formData = new FormData();
      formData.append('file',this.excelFile);
      try{
        const { code, msg } = await this.$API.addUpgradeFiles(formData);
        if(code !== 0) throw { msg };
        this.$msg({
          type:'success',
          message:msg,
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$msg({
          type:'error',
          message:msg,
        });
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header{
  border-bottom: 1px solid #eee;
}
::v-deep .el-dialog__body{
  padding-bottom: 0;
}
.form{
  padding: 40px 0;
  .up__btn{
    text-align: center;
    .label{
      margin-top: 20px;
    }
    .el-icon-upload{
      font-size: 60px;
    }
    .el-upload:active{
      color:#FFF;
    }
  }
  .up__btn .el-upload{
    width: 100%;
  }
  .up__btn .el-upload__text{
    color:#FFF;
    width: 120px;
  }
}
.footer{
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  border-top: 1px solid #eee;
}

</style>
